import { createApp, h } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import HttpAppResponseErrorException from "@/dto/exceptions/httpAppResponseErrorException";

import vueDebounce from "vue-debounce";

import axios from "axios";

//bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";

//styles globaux
import "@/assets/styles/global.scss";
import "@/assets/styles/app-theme.scss";

//fontawesome
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from "@fortawesome/vue-fontawesome";

//svg inline
import InlineSvg from "vue-inline-svg";

//nos libs
import ActionButton from "@/components/ActionButton";
import AppLayout from "@/layouts/AppLayout";
import mitt from "mitt";
const $eventBus = mitt();

axios.defaults.withCredentials = true;
axios.interceptors.response.use(
  (response) => {
    return response.data.error ?? response.data ?? response;
  },
  async (error) => {
    switch (error.response.status) {
      case 401:
        {
          localStorage.clear();
          router.push({
            name: "Login",
          });
        }
        break;
    }

    if (HttpAppResponseErrorException.isHttpAppResponseError(error.response.data)) {
      throw new HttpAppResponseErrorException(error.response.data);
    } else {
      throw error;
    }
  },
);

const vueApp = createApp(App).use(store).use(router);
vueApp.config.globalProperties.$eventBus = $eventBus;
//fontawesome
vueApp.component("font-awesome-icon", FontAwesomeIcon);
vueApp.component("font-awesome-layers", FontAwesomeLayers);
vueApp.component("font-awesome-layers-text", FontAwesomeLayersText);

//svg inline
vueApp.component("inline-svg", InlineSvg);

vueApp.component("v-style", {
  render: function () {
    return h(
      "style", // tag name
      {}, // props/attributes
      this.$slots.default(), // array of children
    );
  },
});
vueApp.directive("debounce", vueDebounce({ lock: true, listenTo: "click", defaultTime: "300ms" }));

//nos composants
vueApp.component("action-button", ActionButton);
vueApp.component("AppLayout", AppLayout);
vueApp.mount("#app");
